export class RouteConstants {

  public static DEFAULT = '';
  public static UN_AUTORIZED = 'unauthorized';
}
